import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { SelfDestruct } from 'src/shared/utilities/self-destruct';
import { takeUntil, filter } from 'rxjs/operators';
import { newDocumentRequestFormConfig } from '../add-document/add-document.component';

/*
	TODO come up with a better approach to this. Right now I _need_
	a FormGroup type back from this dialog. Only problem is it's
	accessing values from components that implement the CVA, which
	can only be listened to through a FormControl. So I'm having to
	do some manual mapping from formcontrol to formgroup.
*/

@Component({
	selector: 'rpshared-add-document-dialog',
	templateUrl: './add-document-dialog.component.html',
})
export class AddDocumentDialogComponent extends SelfDestruct implements OnInit {
	// CVA components can only be listened to through a form control
	control = new FormControl('') as FormControl;

	group = this.fb.group(newDocumentRequestFormConfig) as FormGroup;

	constructor(private readonly fb: FormBuilder) {
		super();
	}

	ngOnInit() {
		this.control.valueChanges
			.pipe(filter(Boolean), takeUntil(this.destroyed))
			.subscribe((v) => this.group.patchValue(v));
	}
}
